import { extendTheme } from '@mui/joy/styles';
import { DefaultPaletteRange, PaletteVariant, PaletteRange } from '@mui/joy/styles/types';
// import { Inter, Source_Code_Pro } from 'next/font/google';
import {
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  experimental_extendTheme as extendMaterialTheme,
  THEME_ID
} from "@mui/material/styles";

declare module '@mui/joy/styles' {
  interface ColorPalettePropOverrides {
    default: true;
    business: true;
    contact: true;
    workplan: true;
    property: true;
    event: true;
    note: true;
  }

  interface Palette {
    default: PaletteRange;
    business: PaletteRange;//DefaultPaletteRange & PaletteVariant;
    contact: PaletteRange;//DefaultPaletteRange & PaletteVariant;
    workplan: PaletteRange;//DefaultPaletteRange & PaletteVariant;
    property: PaletteRange;//DefaultPaletteRange & PaletteVariant;
    event: PaletteRange;//DefaultPaletteRange & PaletteVariant;
    note: PaletteRange;//DefaultPaletteRange & PaletteVariant;
  }
}

/*
const inter = Inter({
  subsets: ['latin'],
  adjustFontFallback: false, // prevent NextJS from adding its own fallback font
  fallback: ['var(--joy-fontFamily-fallback)'], // use Joy UI's fallback font
  display: 'swap',
});

const sourceCodePro = Source_Code_Pro({
  subsets: ['latin'],
  adjustFontFallback: false, // prevent NextJS from adding its own fallback font
  fallback: [
    // the default theme's fallback for monospace fonts
    'ui-monospace',
    'SFMono-Regular',
    'Menlo',
    'Monaco',
    'Consolas',
    'Liberation Mono',
    'Courier New',
    'monospace',
  ],
  display: 'swap',
});
*/

function generateColorObj(colors:string[], invert:boolean = false) {
  let obj = {};//<number, string>
  let order = [];

  if(invert) {
    order = [
      900, 800, 700, 600, 500, 400, 300, 200, 100, 50,
    ];
  } else {
    order = [
      50, 100, 200, 300, 400, 500, 600, 700, 800, 900,
    ];
  }

  for(const i in order) {
    obj[order[i]] = colors[i];
  }

  return obj;
}
export const colorSchemes = {
    light: {
      palette: {
        default: {
          //5b5b5b
          // DEFAULT: '#5B5B5B',
          50: '#F0F0F0',
          100: '#E0E0E0',
          200: '#BEBEBE',
          300: '#9D9D9D',
          400: '#7C7C7C',
          500: '#5B5B5B',
          600: '#4C4C4C',
          700: '#3C3C3C',
          800: '#2D2D2D',
          900: '#1E1E1E',
          950: '#161616',
          solidColor: '#fff',//'var(--joy-palette-default-50)',
          solidBg: 'var(--joy-palette-default-400)',
          solidHoverBg: 'var(--joy-palette-default-500)',
          solidActiveBg: 'var(--joy-palette-default-500)',
          outlinedBorder: 'var(--joy-palette-default-500)',
          outlinedColor: 'var(--joy-palette-default-700)',
          outlinedActiveBg: 'var(--joy-palette-default-100)',
          softColor: 'var(--joy-palette-default-800)',
          softBg: 'var(--joy-palette-default-200)',
          softActiveBg: 'var(--joy-palette-default-300)',
          plainColor: 'var(--joy-palette-default-700)',
          plainActiveBg: 'var(--joy-palette-default-100)',
        },

        neutral: {
          // copied from tailwind zinc
          50: '#fafafa',
          100: '#f4f4f5',
          200: '#e4e4e7',
          300: '#d4d4d8',
          400: '#a1a1aa',
          500: '#71717a',
          600: '#52525b',
          700: '#3f3f46',
          800: '#27272a',
          900: '#18181b',
          950: '#09090b',
        },

        primary: {
          ...generateColorObj([
          // DEFAULT: '#A9343A',
          /*50:*/ '#F1D2D3',
          /*100:*/ '#EBBEC0',
          /*200:*/ '#DF979B',
          /*300:*/ '#D37075',
          /*400:*/ '#C7494F',
          /*500:*/ '#A9343A',
          /*600:*/ '#8A2A2F',
          /*700:*/ '#6B2125',
          /*800:*/ '#4B171A',
          /*900:*/ '#2C0E0F',
          // 950: '#1D090A'
        ]),
          50: "#FBE5E6",
          100: "#F7CFD0",
          200: "#EE9B9D",
          300: "#E66B6F",
          400: "#DE3B40",
          500: "#BD2025",
          600: "#991A1E",
          700: "#711316",
          800: "#4A0D0F",
          900: "#270708",
          950: "#110303"
        },

        business: {
          // DEFAULT: '#6BABAE',
          50: '#E2EEEF',
          100: '#D4E7E8',
          200: '#BAD8D9',
          300: '#A0C9CB',
          400: '#85BABC',
          500: '#6BABAE',
          600: '#508E91',
          700: '#3C6B6D',
          800: '#284749',
          900: '#142425',
          // 950: '#0A1212'
          solidColor: '#fff',//'var(--joy-palette-business-50)',
          solidBg: 'var(--joy-palette-business-400)',
          solidHoverBg: 'var(--joy-palette-business-500)',
          solidActiveBg: 'var(--joy-palette-business-500)',
          outlinedBorder: 'var(--joy-palette-business-500)',
          outlinedColor: 'var(--joy-palette-business-700)',
          outlinedActiveBg: 'var(--joy-palette-business-100)',
          softColor: 'var(--joy-palette-business-800)',
          softBg: 'var(--joy-palette-business-200)',
          softActiveBg: 'var(--joy-palette-business-300)',
          plainColor: 'var(--joy-palette-business-700)',
          plainActiveBg: 'var(--joy-palette-business-100)',
        },

        contact: {
          // DEFAULT: '#C66B6E',
          50: '#F9F0F0',
          100: '#F3E1E1',
          200: '#E8C3C5',
          300: '#DDA6A8',
          400: '#D1888B',
          500: '#C66B6E',
          600: '#B44549',
          700: '#8B3638',
          800: '#632628',
          900: '#3A1618',
          // 950: '#260F0F'
          solidColor: 'var(--joy-palette-contact-800)',
          solidBg: 'var(--joy-palette-contact-400)',
          solidActiveBg: 'var(--joy-palette-contact-500)',
          outlinedBorder: 'var(--joy-palette-contact-500)',
          outlinedColor: 'var(--joy-palette-contact-700)',
          outlinedActiveBg: 'var(--joy-palette-contact-100)',
          softColor: 'var(--joy-palette-contact-800)',
          softBg: 'var(--joy-palette-contact-200)',
          softActiveBg: 'var(--joy-palette-contact-300)',
          plainColor: 'var(--joy-palette-contact-700)',
          plainActiveBg: 'var(--joy-palette-contact-100)',
        },

        workplan: {
          // DEFAULT: '#62B995',
          50: '#E1F2EB',
          100: '#D3EBE1',
          200: '#B7DFCE',
          300: '#9AD2BB',
          400: '#7EC6A8',
          500: '#62B995',
          600: '#469D79',
          700: '#35765B',
          800: '#234F3D',
          900: '#12291F',
          // 950: '#091510'
          solidBg: 'var(--joy-palette-workplan-400)',
          solidActiveBg: 'var(--joy-palette-workplan-500)',
          outlinedBorder: 'var(--joy-palette-workplan-500)',
          outlinedColor: 'var(--joy-palette-workplan-700)',
          outlinedActiveBg: 'var(--joy-palette-workplan-100)',
          softColor: 'var(--joy-palette-workplan-800)',
          softBg: 'var(--joy-palette-workplan-200)',
          softActiveBg: 'var(--joy-palette-workplan-300)',
          plainColor: 'var(--joy-palette-workplan-700)',
          plainActiveBg: 'var(--joy-palette-workplan-100)',
        },

        property: {
          // DEFAULT: '#7E6EAD',
          50: '#E6E3EF',
          100: '#DBD6E8',
          200: '#C4BCD9',
          300: '#ACA2CA',
          400: '#9588BC',
          500: '#7E6EAD',
          600: '#625291',
          700: '#4A3E6D',
          800: '#322949',
          900: '#191525',
          // 950: '#0D0B14'
          solidBg: 'var(--joy-palette-property-400)',
          solidActiveBg: 'var(--joy-palette-property-500)',
          outlinedBorder: 'var(--joy-palette-property-500)',
          outlinedColor: 'var(--joy-palette-property-700)',
          outlinedActiveBg: 'var(--joy-palette-property-100)',
          softColor: 'var(--joy-palette-property-800)',
          softBg: 'var(--joy-palette-property-200)',
          softActiveBg: 'var(--joy-palette-property-300)',
          plainColor: 'var(--joy-palette-property-700)',
          plainActiveBg: 'var(--joy-palette-property-100)',
        },

        event: {
          // DEFAULT: '#E5A33F',
          50: '#FBF0E1',
          100: '#F8E8CF',
          200: '#F4D7AB',
          300: '#EFC587',
          400: '#EAB463',
          500: '#E5A33F',
          600: '#D0881C',
          700: '#9E6815',
          800: '#6D470F',
          900: '#3C2708',
          // 950: '#231705',
          solidBg: 'var(--joy-palette-event-400)',
          solidActiveBg: 'var(--joy-palette-event-500)',
          outlinedBorder: 'var(--joy-palette-event-500)',
          outlinedColor: 'var(--joy-palette-event-700)',
          outlinedActiveBg: 'var(--joy-palette-event-100)',
          softColor: 'var(--joy-palette-event-800)',
          softBg: 'var(--joy-palette-event-200)',
          softActiveBg: 'var(--joy-palette-event-300)',
          plainColor: 'var(--joy-palette-event-700)',
          plainActiveBg: 'var(--joy-palette-event-100)',
        },

        note: {
          // DEFAULT: '#6477A4',
          50: '#D8DDE8',
          100: '#CBD1E0',
          200: '#B1BBD1',
          300: '#97A4C2',
          400: '#7E8EB3',
          500: '#6477A4',
          600: '#4D5D83',
          700: '#384460',
          800: '#232B3C',
          900: '#0F1219',
          // 950: '#040507'
          solidBg: 'var(--joy-palette-note-400)',
          solidActiveBg: 'var(--joy-palette-note-500)',
          outlinedBorder: 'var(--joy-palette-note-500)',
          outlinedColor: 'var(--joy-palette-note-700)',
          outlinedActiveBg: 'var(--joy-palette-note-100)',
          softColor: 'var(--joy-palette-note-800)',
          softBg: 'var(--joy-palette-note-200)',
          softActiveBg: 'var(--joy-palette-note-300)',
          plainColor: 'var(--joy-palette-note-700)',
          plainActiveBg: 'var(--joy-palette-note-100)',
        }
      }
    },
    dark: {
      palette: {
        primary: {
          /*
          // DEFAULT: '#A9343A',
          50: '#F1D2D3',
          100: '#EBBEC0',
          200: '#DF979B',
          300: '#D37075',
          400: '#C7494F',
          500: '#A9343A',
          600: '#8A2A2F',
          700: '#6B2125',
          800: '#4B171A',
          900: '#2C0E0F',
          // 950: '#1D090A'
          */
          ...generateColorObj([
            // DEFAULT: '#A9343A',
            /*50:*/ '#F1D2D3',
            /*100:*/ '#EBBEC0',
            /*200:*/ '#DF979B',
            /*300:*/ '#D37075',
            /*400:*/ '#C7494F',
            /*500:*/ '#A9343A',
            /*600:*/ '#8A2A2F',
            /*700:*/ '#6B2125',
            /*800:*/ '#4B171A',
            /*900:*/ '#2C0E0F',
            // 950: '#1D090A'
          ], true)
        },

        business: {
          ...generateColorObj([
          // DEFAULT: '#6BABAE',
          /*50:*/ '#E2EEEF',
          /*100:*/ '#D4E7E8',
          /*200:*/ '#BAD8D9',
          /*300:*/ '#A0C9CB',
          /*400:*/ '#85BABC',
          /*500:*/ '#6BABAE',
          /*600:*/ '#508E91',
          /*700:*/ '#3C6B6D',
          /*800:*/ '#284749',
          /*900:*/ '#142425',
          // 950: '#0A1212'
          ], true),
        },

        contact: {
          ...generateColorObj([
          // DEFAULT: '#C66B6E',
          /*50:*/ '#F9F0F0',
          /*100:*/ '#F3E1E1',
          /*200:*/ '#E8C3C5',
          /*300:*/ '#DDA6A8',
          /*400:*/ '#D1888B',
          /*500:*/ '#C66B6E',
          /*600:*/ '#B44549',
          /*700:*/ '#8B3638',
          /*800:*/ '#632628',
          /*900:*/ '#3A1618',
          // 950: '#260F0F'
          ], true),
        },

        workplan: {
          ...generateColorObj([
          // DEFAULT: '#62B995',
          /*50:*/ '#E1F2EB',
          /*100:*/ '#D3EBE1',
          /*200:*/ '#B7DFCE',
          /*300:*/ '#9AD2BB',
          /*400:*/ '#7EC6A8',
          /*500:*/ '#62B995',
          /*600:*/ '#469D79',
          /*700:*/ '#35765B',
          /*800:*/ '#234F3D',
          /*900:*/ '#12291F',
          // 950: '#091510'
          ], true),
        },

        property: {
          ...generateColorObj([
          // DEFAULT: '#7E6EAD',
          /*50:*/ '#E6E3EF',
          /*100:*/ '#DBD6E8',
          /*200:*/ '#C4BCD9',
          /*300:*/ '#ACA2CA',
          /*400:*/ '#9588BC',
          /*500:*/ '#7E6EAD',
          /*600:*/ '#625291',
          /*700:*/ '#4A3E6D',
          /*800:*/ '#322949',
          /*900:*/ '#191525',
          // 950: '#0D0B14'
          ], true),
        },

        event: {
          ...generateColorObj([
          // DEFAULT: '#E5A33F',
          /*50:*/ '#FBF0E1',
          /*100:*/ '#F8E8CF',
          /*200:*/ '#F4D7AB',
          /*300:*/ '#EFC587',
          /*400:*/ '#EAB463',
          /*500:*/ '#E5A33F',
          /*600:*/ '#D0881C',
          /*700:*/ '#9E6815',
          /*800:*/ '#6D470F',
          /*900:*/ '#3C2708',
          // 950: '#231705',
          ], true),
        },

        note: {
          ...generateColorObj([
          // DEFAULT: '#6477A4',
          /*50:*/ '#D8DDE8',
          /*100:*/ '#CBD1E0',
          /*200:*/ '#B1BBD1',
          /*300:*/ '#97A4C2',
          /*400:*/ '#7E8EB3',
          /*500:*/ '#6477A4',
          /*600:*/ '#4D5D83',
          /*700:*/ '#384460',
          /*800:*/ '#232B3C',
          /*900:*/ '#0F1219',
          // 950: '#040507'
          ], true),
        }
      }
    }
};

const theme = extendTheme({
  colorSchemes,
  /*
  fontFamily: {
    body: inter.style.fontFamily,
    display: inter.style.fontFamily,
    // code: sourceCodePro.style.fontFamily,
  },
  */
  // Todo: figure out how to add an xs size for menus
  components: {
    JoyTable: {
      styleOverrides: {
        root: {
          '--TableRow-stripeBackground': 'var(--joy-palette-background-level1)',
        }
      },
      //
      // --TableRow-stripeBackground
    },
    /*
    JoyMenu: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.size === 'xs' && {
            '--ListDivider-gap': '0.25rem',
            '--ListItem-minHeight': '1rem',
            '--ListItem-paddingY': '1px',
            '--ListItem-paddingX': ownerState.marker ? '1px' : '0.25rem',
            '--ListItem-gap': '0.25rem',
            '--ListItemDecorator-size': ownerState.orientation === 'horizontal' ? '1.5rem' : '2rem',
            '--Icon-fontSize': theme.vars.fontSize.xs,

            // '--Icon-fontSize': '1rem',
            '--Button-gap': '0.25rem',
            fontSize: theme.vars.fontSize.xs,
            paddingBlock: '2px',
            paddingInline: '0.5rem',
          }),
        }),
      }
    },
    JoyButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.size === 'xs' && {
            '--Icon-fontSize': '1rem',
            '--Button-gap': '0.25rem',
            minHeight: 'var(--Button-minHeight, 1.75rem)',
            fontSize: theme.vars.fontSize.xs,
            paddingBlock: '2px',
            paddingInline: '0.5rem',
          }),
        }),
      },
    },
    */
  },
});

export default theme;


const materialTheme = extendMaterialTheme({
  cssVarPrefix: "joy",
  colorSchemes,
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          boxShadow: 'var(--joy-shadowRing, 0 0 #000),0px 1px 2px 0px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08)) !important',
          borderRadius: 'var(--joy-radius-sm) !important',
          // borderColor: 'var(--variant-outlinedBorder, var(--joy-palette-neutral-outlinedBorder, var(--joy-palette-neutral-300, #CDD7E1))) !important',
          backgroundColor: 'var(--joy-palette-background-surface) !important',
          // '--joy-palette-common-onBackgroundChannel': 'red',
          //rgba(var(--joy-palette-common-onBackgroundChannel) / 0.23)
          '&:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--variant-outlinedBorder, var(--joy-palette-neutral-outlinedBorder, var(--joy-palette-neutral-300, #CDD7E1))) !important',
            //
          },
          '& .MuiButtonBase-root': {
            padding: '6px !important',
            borderRadius: '4px !important',
            // marginRight: '-10px',
            '&:hover': {
              backgroundColor: 'var(--variant-plainHoverBg, var(--joy-palette-neutral-plainHoverBg, var(--joy-palette-neutral-100, #F0F4F8)))',
              color: 'var(--variant-plainHoverColor, var(--joy-palette-neutral-plainHoverColor, var(--joy-palette-neutral-900, #0B0D0E)))',
            },
            '& svg': {
              '--Icon-fontSize': 'var(--joy-fontSize-md)',
              fontSize: 'var(--Icon-fontSize, var(--joy-fontSize-xl2))',
            }
          },
          '& .MuiInputAdornment-root:last-of-type': {
            marginRight: '2px',
          },
        },
        input: {
          // padding: '.4rem 0 .4rem 1rem',
          paddingTop: '0.4rem !important',
          paddingBottom: '0.4rem !important',
          paddingLeft: '1rem !important',
          paddingRight: '1rem',
        },
      },
    },

    // MuiPickers
    //
  },
});

export function MaterialThemeWrapper(props) {
  return (
    <MaterialCssVarsProvider theme={{ [THEME_ID]: materialTheme }}>
      {props.children}
    </MaterialCssVarsProvider>

  );
}
